/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Predictsnp
 */
export interface Predictsnp {
    /**
     * 
     * @type {string}
     * @memberof Predictsnp
     */
    jobId: string;
    /**
     * 
     * @type {boolean}
     * @memberof Predictsnp
     */
    deleterious: boolean;
    /**
     * 
     * @type {number}
     * @memberof Predictsnp
     */
    confidence: number;
}

/**
 * Check if a given object implements the Predictsnp interface.
 */
export function instanceOfPredictsnp(value: object): value is Predictsnp {
    if (!('jobId' in value) || value['jobId'] === undefined) return false;
    if (!('deleterious' in value) || value['deleterious'] === undefined) return false;
    if (!('confidence' in value) || value['confidence'] === undefined) return false;
    return true;
}

export function PredictsnpFromJSON(json: any): Predictsnp {
    return PredictsnpFromJSONTyped(json, false);
}

export function PredictsnpFromJSONTyped(json: any, ignoreDiscriminator: boolean): Predictsnp {
    if (json == null) {
        return json;
    }
    return {
        
        'jobId': json['jobId'],
        'deleterious': json['deleterious'],
        'confidence': json['confidence'],
    };
}

export function PredictsnpToJSON(json: any): Predictsnp {
    return PredictsnpToJSONTyped(json, false);
}

export function PredictsnpToJSONTyped(value?: Predictsnp | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'jobId': value['jobId'],
        'deleterious': value['deleterious'],
        'confidence': value['confidence'],
    };
}

